export const SERVICE_CODE = 'EXPENSE' + '_REPORT' + '_SERVICE';
